import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import * as tx from '../../../../constants/strings';

import { stringFormat } from '../../../../utils/formatting';

import { LoadingIcon } from '../../../Icons/LoadingIcon';

const allActionCreators = Object.assign({});

export class BlockAnalyticsSalesGraph extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };

    // Controllers
    this.controller = null;
  }

  componentDidMount() {
    this.fetchData(); 
  }

  componentWillUnmount() {
    if(this.controller) {
      this.controller.abort();
    }
  }

  async fetchData() {

    // if(!this.state.productLine) { return null; }
    
    // // Cancel any existing requests
    // if(this.controller) {
    //   this.controller.abort();
    // }
    // const controller = new AbortController();
    // this.controller = controller;

    // this.setState({ 
    //   loading: true, 
    // });

    // const requestFilters = {
    //   [FV_KEY_IS_SEALED]: true,
    //   [FV_KEY_PRODUCT_LINE]: [ this.state.productLine.permalink ],
    //   [FV_KEY_DISPLAY_MIN]: 'True',
    // };

    // const paginationData = {
    //   limit: this.REQUEST_COUNT,
    //   offset: 0,
    // }

    // const reqFilterObject = Object.assign({}, requestFilters, paginationData);
    // const productResp = await this.props.productSearchInventory(reqFilterObject, controller.signal)
    //   .catch((errResp) => {
    //     this.setState({
    //       productData: [],
    //       loading: false, 
    //     });
    //   });

    // if(!productResp) {
    //   return null;
    // }

    // this.setState({
    //   productData: productResp.data,
    //   loading: false, 
    // });
  }

  render() {

    const {t} = this.props;

    return <div className={'BlockAnalyticsSalesGraph BlockTypeAnalytics'}>
      BlockAnalyticsSalesGraph
    </div>;
  }
}

function mapStateToProps(state) {
  return {
    
  };
}

export default connect(mapStateToProps, allActionCreators)(withTranslation()(BlockAnalyticsSalesGraph));